import { API } from 'aws-amplify';
import {
  SET_ROUTE_EIRCODE,
  SET_ROUTE_NAME,
  SET_ROUTE_HIGHWAY,
  SET_ROUTE_TYPE,
  SET_ROUTE_REL_ALT,
  CREATING_ROUTE_REQUEST,
  CREATING_ROUTE_SUCCESS,
  CREATING_ROUTE_FAILURE,
  UPDATING_ROUTE_REQUEST,
  UPDATING_ROUTE_SUCCESS,
  UPDATING_ROUTE_FAILURE,
  DELETE_ROUTE_REQUEST,
  DELETE_ROUTE_SUCCESS,
  DELETE_ROUTE_FAILURE,
  ENABLE_ROUTE_REQUEST,
  ENABLE_ROUTE_SUCCESS,
  ENABLE_ROUTE_FAILURE,
  FETCH_ROUTES_REQUEST,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  CLEAR_UPDATE_ROUTE,
  TOGGLE_NEW_LINE_AND_POINTS,
  TOGGLE_UPDATE_LINE_AND_POINTS,
  SHOW_DELETE_CONFIRM,
  CLOSE_DELETE_CONFIRM,
  QUEUE_NOTIFICATION,
  CLEAR_NEW_ROUTE,
  SET_TAB,
  SET_UPDATE_GEOJSON,
  SET_NEW_GEOJSON,
  SET_UPDATE_ROUTE,
  SET_NEW_ROUTE,
  SET_UPDATE_ROUTE_START_POINT_ELEVATION,
  SET_UPDATE_ROUTE_START_POINT,
  SET_UPDATE_ROUTE_ELEVATION_POINTS,
  SET_NEW_ROUTE_START_POINT_ELEVATION,
  SET_NEW_ROUTE_ELEVATION_POINTS,
  SET_NEW_ROUTE_START_POINT,
  SET_DRONE_ELEVATION_PATH,
  SET_DRONE_ALTITUDE_PATH,
  SET_UPDATE_ROUTE_REL_ALT,
  FETCH_ROUTE_QR_CODE,
  FETCH_ROUTE_QR_CODE_FAILURE,
  FETCH_ROUTE_QR_CODE_SUCCESS,
  GET_ALL_ADDRESS_LOCATIONS,
  SET_DISABLE_SLOPED_ASCENT,
  ADD_SELECTED_HEXES,
  SET_OBSTACLE_TYPE,
  CLEAR_OBSTACLES_SELECTED,
  SET_EXISTING_OBSTACLES,
  LOADING_OBSTACLES_REGION,
  SET_HAS_DELETED_OBSTACLE
} from './actionTypes';
import { requestOptions } from '../constants';
import Axios from 'axios';
import { arrayToKeys } from 'utils/parsingUtils';
import { decToHex } from 'hex2dec';
import { newNotification } from './uiActions';
export const createRoute = (
  lineString,
  name,
  routeModeDev,
  disableSlopedAscent
) => dispatch => {
  dispatch({ type: CREATING_ROUTE_REQUEST });
  const queryString = `/addressfind/addRouteFromLineString?name=${name}&mode=${routeModeDev}&disableSlope=${disableSlopedAscent}`;
  API.post('api', queryString, { body: JSON.parse(lineString) }, requestOptions)
    .then(res => {
      dispatch({ type: CREATING_ROUTE_SUCCESS, payload: res });
      dispatch(getRoutes());
    })
    .catch(err => {
      dispatch({ type: CREATING_ROUTE_FAILURE, payload: err });
    });
};

export const updateRoute = (updateRouteObject, relAlt) => dispatch => {
  dispatch({ type: UPDATING_ROUTE_REQUEST });
  API.put(
    'api',
    `/addressfind?autoRelativeAlt=${relAlt}`,
    { body: updateRouteObject },
    requestOptions
  )
    .then(res => {
      dispatch({ type: UPDATING_ROUTE_SUCCESS, payload: res });
      dispatch(getRoutes());
    })
    .catch(err => {
      dispatch({ type: UPDATING_ROUTE_FAILURE, payload: err });
    });
};

export const deleteRoute = (id, eircode) => dispatch => {
  dispatch({ type: DELETE_ROUTE_REQUEST });
  API.del('api', `/addressfind?id=${id}`)
    .then(() => {
      dispatch({ type: DELETE_ROUTE_SUCCESS, payload: eircode });
      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'Route deleted'
        }
      });
    })
    .catch(() => {
      dispatch({ type: DELETE_ROUTE_FAILURE });
      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'error',
          message: 'Could not delete route'
        }
      });
    });
};

export const getRoute = (id, success, failure) => {
  API.get('api', `/addressfind/${id}`)
    .then(res => {
      console.log(res);
      success(res);
    })
    .catch(e => {
      failure(e);
    });
};

export const getRoutes = () => dispatch => {
  dispatch({ type: FETCH_ROUTES_REQUEST });
  API.get('api', '/addressfind/list-all')
    .then(res => {
      const { objectWithKeys, keys } = arrayToKeys('eircode', res);
      const highwayKeys = keys.filter(key => {
        if (key) return key.includes('HW_');
        return false;
      });
      dispatch({
        type: FETCH_ROUTES_SUCCESS,
        payload: {
          routesKeys: keys,
          highwayKeys: highwayKeys,
          routes: objectWithKeys
        }
      });
    })
    .catch(e => {
      dispatch({ type: FETCH_ROUTES_FAILURE });
    });
};

export const toggleEnableRoute = route => dispatch => {
  dispatch({ type: ENABLE_ROUTE_REQUEST });
  const newRouteWithEnabledState = route;
  newRouteWithEnabledState.enabled = !newRouteWithEnabledState.enabled;
  API.put('api', '/addressfind/', {
    body: {
      ...newRouteWithEnabledState,
      misc1: JSON.stringify(newRouteWithEnabledState.misc1),
      misc2: JSON.stringify(newRouteWithEnabledState.misc2)
    }
  })
    .then(res => {
      dispatch({
        type: ENABLE_ROUTE_SUCCESS,
        payload: newRouteWithEnabledState
      });
    })
    .catch(() => {
      console.log(JSON.stringify(route));
      console.log('Failed to update route: ', route);
      dispatch({ type: ENABLE_ROUTE_FAILURE });
    });
};

export const getAddressLocations = cellId => dispatch => {
  API.get('api', `/addressfind/list-all?cellId=${cellId}`)
    .then(res => {
      dispatch({
        type: GET_ALL_ADDRESS_LOCATIONS,
        payload: res
      });
    })
    .catch(err => {
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed to fetch addresses: ' + err
        })
      );
    });
};

export const updateAddressEnabledStatus = (addressID, isEnabled) => dispatch => {
  return API.put('api', `/addressfind/${addressID}/enabledStatus?isEnabled=${isEnabled}`, {})
    .then(res => {
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated address successfully'
        })
      );
      return res;
    })
    .catch(err => {
      console.log(err);
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed to update address: ' + err
        })
      );
      throw err;
    });
};

export const updateAddress = (addressID, address) => dispatch => {
  return API.put('api', `/addressfind/${addressID}`, {
    body: address
  })
    .then(res => {
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated address successfully'
        })
      );
      return res;
    })
    .catch(err => {
      console.log(err);
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed to update address: ' + err
        })
      );
      throw err;
    });
};

export const getRouteQRCode = devRouteName => dispatch => {
  dispatch({ type: FETCH_ROUTE_QR_CODE });
  API.get('api', `/order/route/${devRouteName}`)
    .then(res => {
      dispatch({
        type: FETCH_ROUTE_QR_CODE_SUCCESS,
        payload: res.base64QrCode
      });
    })
    .catch(err => {
      dispatch({ type: FETCH_ROUTE_QR_CODE_FAILURE });
    });
};

export const getElevation = coordsString => {
  return Axios.get(
    `https://elv.manna.aero/api/v1/lookup?locations=${coordsString}`
  );
};

export const toggleNewLineAndPoints = showLine => dispatch => {
  dispatch({ type: TOGGLE_NEW_LINE_AND_POINTS, payload: showLine });
};

export const toggleUpdateLineAndPoints = showLine => dispatch => {
  dispatch({ type: TOGGLE_UPDATE_LINE_AND_POINTS, payload: showLine });
};

export const setNewRoute = route => dispatch => {
  dispatch({ type: SET_NEW_ROUTE, payload: route });
};

export const setNewGeoJson = geoJson => dispatch => {
  dispatch({ type: SET_NEW_GEOJSON, payload: geoJson });
};

export const clearNewRoute = () => dispatch => {
  dispatch({ type: CLEAR_NEW_ROUTE });
};

export const setUpdateRoute = route => dispatch => {
  dispatch({ type: SET_UPDATE_ROUTE, payload: route });
};

export const setUpdateGeoJson = geoJson => dispatch => {
  dispatch({ type: SET_UPDATE_GEOJSON, payload: geoJson });
};

export const clearUpdateRoute = () => dispatch => {
  dispatch({ type: CLEAR_UPDATE_ROUTE });
};

export const showDeleteConfirm = (eircode, id) => dispatch => {
  dispatch({ type: SHOW_DELETE_CONFIRM, payload: { eircode, id } });
};

export const closeDeleteConfirm = () => dispatch => {
  dispatch({ type: CLOSE_DELETE_CONFIRM });
};

export const setTab = tab => dispatch => {
  dispatch({ type: SET_TAB, payload: tab });
};

export const setRouteEircode = eircode => dispatch => {
  dispatch({ type: SET_ROUTE_EIRCODE, payload: eircode });
};

export const setRouteName = name => dispatch => {
  dispatch({ type: SET_ROUTE_NAME, payload: name });
};

export const setHighway = highway => dispatch => {
  dispatch({ type: SET_ROUTE_HIGHWAY, payload: highway });
};

export const setRouteType = type => dispatch => {
  dispatch({ type: SET_ROUTE_TYPE, payload: type });
};

export const setRouteRelAlt = relAlt => dispatch => {
  dispatch({ type: SET_ROUTE_REL_ALT, payload: relAlt });
};
export const setDisableSlopedAscent = disableSlopedAscent => ({
  type: SET_DISABLE_SLOPED_ASCENT,
  payload: disableSlopedAscent
});

export const setUpdateRouteRelAlt = relAlt => dispatch => {
  dispatch({ type: SET_UPDATE_ROUTE_REL_ALT, payload: relAlt });
};

export const setNewRouteElevationPoints = points => dispatch => {
  dispatch({ type: SET_NEW_ROUTE_ELEVATION_POINTS, payload: points });
};

export const setNewRouteStartPointElevation = startPointElevation => dispatch => {
  dispatch({
    type: SET_NEW_ROUTE_START_POINT_ELEVATION,
    payload: startPointElevation
  });
};

export const setNewRouteStartPoint = startPoint => dispatch => {
  dispatch({ type: SET_NEW_ROUTE_START_POINT, payload: startPoint });
};

export const setUpdateRouteElevationPoints = points => dispatch => {
  dispatch({ type: SET_UPDATE_ROUTE_ELEVATION_POINTS, payload: points });
};

export const setUpdateRouteStartPointElevation = startPointElevation => dispatch => {
  dispatch({
    type: SET_UPDATE_ROUTE_START_POINT_ELEVATION,
    payload: startPointElevation
  });
};

export const setUpdateRouteStartPoint = startPoint => dispatch => {
  dispatch({ type: SET_UPDATE_ROUTE_START_POINT, payload: startPoint });
};

export const setDroneElevationPath = path => dispatch => {
  dispatch({ type: SET_DRONE_ELEVATION_PATH, payload: path });
};

export const setDroneAltitudePath = path => dispatch => {
  dispatch({ type: SET_DRONE_ALTITUDE_PATH, payload: path });
};

export const addSelectedHexes = hexes => dispatch => {
  dispatch({
    type: ADD_SELECTED_HEXES,
    payload: hexes
  });
};

export const setLoadingObstacles = loading => dispatch => {
  dispatch({
    type: LOADING_OBSTACLES_REGION,
    payload: loading
  });
};

export const setObstacleType = currentObstacleType => dispatch => {
  dispatch({
    type: SET_OBSTACLE_TYPE,
    payload: currentObstacleType
  });
};

export const clearObstacleSelected = () => dispatch => {
  dispatch({
    type: CLEAR_OBSTACLES_SELECTED
  });
};

export const setExistingObstacles = obstaclesWithTypes => dispatch => {
  dispatch({
    type: SET_EXISTING_OBSTACLES,
    payload: obstaclesWithTypes
  });
};

export const setHasDeletedObstacles = () => dispatch => {
  dispatch({
    type: SET_HAS_DELETED_OBSTACLE
  });
};

const splitObstacleDataIntoTypes = decimalsWithType => {
  const obstacleTypes = {};
  decimalsWithType.forEach(decimalWithType => {
    const splitHex = decimalWithType.split(':');
    const type = splitHex[1];
    const hex = decToHex(splitHex[0], { prefix: false });
    if (obstacleTypes[type]) {
      obstacleTypes[type].push(hex);
    } else {
      obstacleTypes[type] = [hex];
    }
  });
  return obstacleTypes;
};

const parseUncompressedData = data => {
  const removedString = data.replaceAll('"', '');
  const stringifiedItems = removedString
    .replaceAll('[', '')
    .replaceAll(']', '')
    .replaceAll(' ', '')
    .split(',');
  return stringifiedItems;
};

export const getObstacleData = coords => dispatch => {
  dispatch(setLoadingObstacles(true));
  API.get('flightapi', `/airspace/zones/${coords.lat}/${coords.lng}/LEVEL_1`)
    .then(res => {
      const parsedData = parseUncompressedData(res.uncompressedData);
      const obstacleDataWithTypes = splitObstacleDataIntoTypes(parsedData);
      dispatch({
        type: SET_EXISTING_OBSTACLES,
        payload: obstacleDataWithTypes
      });
    })
    .catch(err => {
      dispatch(setLoadingObstacles(false));
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed to load region: ' + err,
          persist: true
        })
      );
    });
};

const requestObstacles = async coords => {
  try {
    const res = await API.get(
      'flightapi',
      `/airspace/zones/${coords.lat}/${coords.lng}/LEVEL_1`
    );

    const parsedData = parseUncompressedData(res.uncompressedData);
    return splitObstacleDataIntoTypes(parsedData);
  } catch (err) {
    console.log(err);
  }
};

export const getBalbrigganData = () => async dispatch => {
  try {
    const res = await Promise.allSettled([
      await requestObstacles({
        lat: 53.62621534617029,
        lng: -6.203365032930013
      }),
      await requestObstacles({
        lat: 53.61389527953814,
        lng: -6.196843894779562
      }),
      await requestObstacles({
        lat: 53.596681894811965,
        lng: -6.169729688785582
      }),
      await requestObstacles({
        lat: 53.58486272978831,
        lng: -6.195814241387374
      }),
      await requestObstacles({
        lat: 53.60788667012785,
        lng: -6.22636062535526
      }),
      await requestObstacles({
        lat: 53.59199538008336,
        lng: -6.234426243593974
      }),
      await requestObstacles({
        lat: 52.260627229671734,
        lng: -10.048320920477156
      }),
      await requestObstacles({
        lat: 52.261447005758576,
        lng: -10.00600056175876
      }),
      await requestObstacles({
        lat: 52.2427743328624,
        lng: -10.014142825890268
      }),
      await requestObstacles({
        lat: 52.250675019130206,
        lng: -9.99753539037351
      })
    ]);
    const obstacles = res
      ?.filter(result => result.status === 'fulfilled')
      .reduce((prev, curr) => {
        const currKeys = Object.keys(curr.value);

        const merged = currKeys.reduce((previous, current) => {
          let newArr = [];
          const previousObstacles = prev?.[current];
          const currentObstacles = curr?.value?.[current];
          if (previousObstacles) {
            newArr = [...previousObstacles, ...newArr];
          }
          if (currentObstacles) {
            newArr = [...currentObstacles, ...newArr];
          }
          return {
            ...previous,
            [current]: newArr
          };
        }, {});
        return { ...prev, ...merged };
      }, {});
    dispatch({
      type: SET_EXISTING_OBSTACLES,
      payload: obstacles,
      meta: { }
    });
  } catch (err) {
    dispatch(
      newNotification({
        variant: 'error',
        message: `Failed to load obstacles: ` + err,
        persist: true
      })
    );
  }
};

const obstacleDataToByteBufferFormat = data => {
  return JSON.stringify(data).replaceAll('"', '');
};

export const updateObstacleData = (data, id) => dispatch => {
  const obj = {
    id,
    layerLevel: 'LEVEL_1',
    updatedData: obstacleDataToByteBufferFormat(data)
  };
  API.post('flightapi', '/airspace/updateAirspaceZoneData', { body: obj })
    .then(res => {
      const parsedData = parseUncompressedData(res.uncompressedData);
      const obstacleDataWithTypes = splitObstacleDataIntoTypes(parsedData);
      dispatch({
        type: SET_EXISTING_OBSTACLES,
        payload: obstacleDataWithTypes
      });
      dispatch(setHasDeletedObstacles(false));
    })
    .catch(err => {
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Failed to load region: ' + err
        })
      );
    });
};
